// PAAT site content. Keep all frequently changed text, links and image URLs here.
// Replace any image URL below without touching the page components.
export const SITE = {
  brand: {
    shortName: "PAAT",
    fullName: "Padmanabha Automobiles and Association of Travels",
    logoSrc: "./assets/paat-logo.png",
    logoAlt: "PAAT logo",
  },
  contact: {
    phone: "9830195195",
    phoneSecondary: "7003155555",
    email: "padmanabha.99999@gmail.com",
    address: "West Bengal, India",
  },
  hero: {
    overline: "PAAT · West Bengal & Beyond",
    ticker: ["Available 24 / 7", "Doorstep Service"],
    headline: ["Luxury Cars", "& Travel Services", "— At Your Doorstep"],
    subheadline:
      "Rent cars or drivers for any duration · Plan tourist trips across West Bengal · Book wedding, corporate and doorstep driving services.",
    backgroundImage:
      "./assets/paat-hero-kolkata.jpg",
    backgroundAlt: "Premium car ready for a journey",
    primaryCta: "WhatsApp Booking",
    secondaryCta: "Call PAAT",
    badge: "PAAT · Premium Mobility",
    fleetLabel: "Services",
    fleetValue: "04",
    stats: [
      { k: "04", v: "Core Services" },
      { k: "24 / 7", v: "Booking Support" },
      { k: "Any", v: "Car / Model on Request" },
      { k: "WB", v: "Travel Coverage" },
    ],
  },
  navigation: [
    { label: "Services", href: "#services" },
    { label: "Driving School", href: "#doorstep" },
    { label: "Cars", href: "#fleet" },
    { label: "Corporate", href: "#corporate" },
    { label: "Contact", href: "#contact" },
  ],
  services: [
    {
      id: "driving_school",
      anchor: "doorstep",
      number: "01",
      highlight: true,
      badge: "Doorstep Service",
      title: "Doorstep Driving School",
      description:
        "Learn driving at your doorstep with a car and instructor, or arrange a car-only option. PAAT can also assist with the driving-licence process if required.",
      cta: "Book Driving Service",
      pills: ["At Your Doorstep", "Instructor", "Licence Assistance"],
      image:
        "https://images.pexels.com/photos/3769138/pexels-photo-3769138.jpeg?auto=compress&cs=tinysrgb&w=1400",
    },
    {
      id: "self_drive",
      anchor: "fleet",
      number: "02",
      title: "Car Rental & Tours",
      description:
        "Book a car or driver for any duration, or plan tourist travel across West Bengal. Request your preferred car or model and confirm the final quote with PAAT.",
      cta: "Book a Car / Tour",
      pills: ["With Driver", "Without Driver", "Tours"],
      image:
        "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1400&q=85",
    },
    {
      id: "wedding",
      anchor: "services",
      number: "03",
      title: "Weddings & Events",
      description:
        "Premium cars for weddings, receptions and functions. Book one car or multiple cars, with or without professional drivers, based on your event plan.",
      cta: "Get Event Quote",
      pills: ["Wedding", "Functions", "Multiple Cars"],
      image:
        "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=85",
    },
    {
      id: "corporate_fleet",
      anchor: "corporate",
      number: "04",
      title: "Corporate & Hotels",
      description:
        "Cars and professional drivers for hotels, companies and corporate contracts. Choose a short-term rental or monthly arrangement and negotiate the final requirement with PAAT.",
      cta: "Inquire Corporate Plan",
      pills: ["Monthly", "Hotels", "Companies"],
      image:
        "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=85",
    },
  ],
  process: [
    { n: "01", title: "Choose a Service", body: "Tell PAAT whether you need a car, driver, tour, event vehicle, corporate arrangement or doorstep driving service." },
    { n: "02", title: "Share Your Requirement", body: "Send your date, duration, preferred car or model and any special requirement by WhatsApp or the enquiry form." },
    { n: "03", title: "Confirm Your Booking", body: "PAAT discusses availability and the final negotiated price with you, then confirms the service." },
  ],
  manifesto: [
    { n: "I.", title: "Your requirement comes first.", body: "From a requested car model to a full event fleet, PAAT keeps the booking flexible so the service can match the customer's actual need." },
    { n: "II.", title: "The service comes to you.", body: "Cars, drivers and driving instruction can be arranged around your location and schedule, making doorstep service a central part of the experience." },
    { n: "III.", title: "Short or long, it stays flexible.", body: "Hourly bookings, day trips, wedding functions, hotel requirements and monthly corporate contracts can all be discussed around the exact requirement." },
    { n: "IV.", title: "One place for mobility.", body: "PAAT brings car rentals, travel, events, corporate mobility and doorstep driving services together under one brand." },
  ],
  marquee: ["Car Rentals", "Tourist Trips", "Wedding Cars", "Corporate Cars", "Doorstep Driving", "Any Car on Request"],
};

export const BRAND = SITE.brand.fullName;
export const PHONE = SITE.contact.phone;
export const PHONE_SECONDARY = SITE.contact.phoneSecondary;
export const PHONE_TEL = `+91${SITE.contact.phone}`;
export const WHATSAPP = `https://wa.me/91${SITE.contact.phoneSecondary}`;
export const EMAIL = SITE.contact.email;
export const ADDRESS = SITE.contact.address;
export const NAV_ITEMS = SITE.navigation;
export const SERVICES = SITE.services;
export const waMessage = (service = "") => {
  const map = {
    driving_school: "Doorstep Driving School",
    wedding: "Weddings & Events car service",
    self_drive: "Car Rental & Tours",
    corporate_fleet: "Corporate & Hotel car service",
    general: "PAAT mobility services",
  };
  const svc = map[service] || map.general;
  return `${WHATSAPP}?text=${encodeURIComponent(`Hi PAAT, I would like to inquire about ${svc}.`)}`;
};
